module.exports = __webpack_public_path__ + "img/ex-pin-civil-rights-legacy.29762803.svg";